<script setup lang="ts">
const content = {
  headline: 'Trustpilot reviews',
  title: 'Wat onze klanten zeggen',
  description: 'Echte ervaringen van mensen die via ons een makelaar hebben gevonden.',
  rating: '4,5',
  totalReviews: 56,
  items: [
    {
      quote:
        'Ik werd heel snel na mijn aanvraag al gebeld en kreeg goed advies. We zijn uiteindelijk in zee gegaan met de aangedragen aankoopmakelaar en een van de aangedragen verkoopmakelaars.',
      rating: 5,
      author: {
        name: 'Sandra',
        verified: true,
      },
    },
    {
      quote:
        'Juistemakelaars reageerden snel, brachten me in contact met lokale bemiddelaars, en checkten of er contact was gelegd en hoe de contacten verlopen waren. Bedankt voor een superservice!',
      rating: 5,
      author: {
        name: 'Jan G.',
        verified: true,
      },
    },
    {
      quote:
        'Eenvoudige manier om snel aan goede makelaars te komen. Na het invullen van de vraag via internet, werd zeer snel telefonisch contact opgenomen. Dezelfde dag nam een makelaar contact op. Dit bleek voor ons ook nog de juiste keuze.',
      rating: 5,
      author: {
        name: 'Carel-Peter Kortlandt',
        verified: true,
      },
    },
    {
      quote:
        'Het is allemaal heel snel, duidelijk en makkelijk verlopen. Binnen een week hadden we twee gesprekken met passende aankoopmakelaars.',
      rating: 5,
      author: {
        name: 'Anneke van der Schaaf',
        verified: true,
      },
    },
    {
      quote:
        'Heel vriendelijk en behulpzaam. Ik werd de volgende dag door twee makelaars in mijn omgeving gebeld. Heel erg bedankt voor de hulp!',
      rating: 5,
      author: {
        name: 'TamBo',
        verified: true,
      },
    },
    {
      quote:
        'Er werd duidelijk en snel gehandeld en er werd binnen no-time contact met mij opgenomen door een makelaar.',
      rating: 4,
      author: {
        name: 'Ruud',
        verified: true,
      },
    },
  ],
  trustpilot: {
    text: 'Trustpilot',
    url: 'https://www.trustpilot.com/review/juistemakelaar.nl',
  },
}
</script>

<template>
  <section class="py-16 bg-muted">
    <UContainer>
      <div class="text-center mb-10">
        <UBadge
          color="primary"
          variant="subtle"
          class="mb-4"
        >
          {{ content.headline }}
        </UBadge>
        <h2 class="text-3xl sm:text-4xl font-bold tracking-[-0.015em] text-highlighted text-balance mb-2">
          {{ content.title }}
        </h2>
        <p class="text-muted text-lg text-pretty">
          {{ content.description }}
        </p>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <div
          v-for="(testimonial, index) in content.items"
          :key="index"
          class="bg-default p-6 rounded-xl border border-default flex flex-col"
        >
          <div class="flex gap-0.5 mb-3">
            <UIcon
              v-for="i in testimonial.rating"
              :key="i"
              name="i-lucide-star"
              class="text-warning size-4"
            />
          </div>
          <p class="text-muted mb-6 flex-1">
            "{{ testimonial.quote }}"
          </p>
          <div class="flex items-center gap-2">
            <span class="font-semibold text-highlighted text-sm">{{ testimonial.author.name }}</span>
            <UBadge
              v-if="testimonial.author.verified"
              color="success"
              variant="subtle"
              size="xs"
            >
              <UIcon
                name="i-lucide-check"
                class="size-3"
              />
              Geverifieerd
            </UBadge>
          </div>
        </div>
      </div>
      <div class="flex items-center justify-center mt-8">
        <NuxtLink
          :to="content.trustpilot.url"
          target="_blank"
          rel="noopener"
          class="flex gap-2 items-center text-sm hover:text-highlighted text-muted transition-colors duration-150"
        >
          <div class="flex gap-0.5">
            <UIcon
              v-for="i in 5"
              :key="i"
              name="i-lucide-star"
              class="text-warning size-4"
            />
          </div>
          <span>{{ content.rating }} / 5 op basis van {{ content.totalReviews }} reviews op</span>
          <UIcon
            name="i-simple-icons-trustpilot"
            class="size-4"
          />
          {{ content.trustpilot.text }}
        </NuxtLink>
      </div>
    </UContainer>
  </section>
</template>
